module.exports = __webpack_public_path__ + "img/other0.875f8ecd.png";